import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "./styles.module.scss";

export const PhoneNumberField = ({
  number,
  onChangeNumber,
  onChangeSaveNumber,
}) => (
  <React.Fragment>
    <input
      type="tel"
      className={cl(classes["PreCallPopup--number-input"], "msh-input")}
      defaultValue={number}
      onChange={({ target }) => onChangeNumber(target.value)}
      autoFocus
    />

    <input
      id="chkSaveNumber"
      type="checkbox"
      name="saveNumber"
      className="ux-checkbox"
      defaultChecked
      onChange={({ target }) => onChangeSaveNumber(target.checked)}
    />
    <label
      htmlFor="chkSaveNumber"
      className={classes["PreCallPopup--save-number-label"]}
    >
      Save this number
    </label>
  </React.Fragment>
);

PhoneNumberField.propTypes = {
  editable: PropTypes.bool,
  number: PropTypes.string.isRequired,
  onChangeNumber: PropTypes.func.isRequired,
  onChangeSaveNumber: PropTypes.func.isRequired,
};

export const PhoneNumber = ({ number }) => (
  <span className={classes["PreCallPopup--number"]}>{number}</span>
);

PhoneNumber.propTypes = {
  number: PropTypes.string.isRequired,
};
